import React, { memo, forwardRef } from "react";
const SvgNumbereight = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.26 12.36c0 .827-.207 1.513-.62 2.06-.413.547-.94.927-1.58 1.14v.04c.373.093.72.247 1.04.46.32.2.6.453.84.76.24.293.427.627.56 1 .147.373.22.78.22 1.22 0 .707-.133 1.333-.4 1.88a3.917 3.917 0 01-1.06 1.36c-.44.373-.96.653-1.56.84-.6.187-1.24.28-1.92.28-.68 0-1.32-.093-1.92-.28a4.608 4.608 0 01-1.58-.84 4.26 4.26 0 01-1.06-1.36c-.253-.547-.38-1.173-.38-1.88 0-.453.073-.873.22-1.26a3.63 3.63 0 01.58-1.02 3.39 3.39 0 01.86-.72c.32-.2.653-.347 1-.44v-.04a3.505 3.505 0 01-1.58-1.1c-.413-.507-.62-1.173-.62-2 0-.6.113-1.14.34-1.62.24-.493.56-.907.96-1.24a4.502 4.502 0 011.42-.8 5.41 5.41 0 011.76-.28c.613 0 1.193.087 1.74.26.547.173 1.02.427 1.42.76.413.333.733.74.96 1.22.24.467.36 1 .36 1.6zm-2.42.14c0-.307-.06-.58-.18-.82a1.715 1.715 0 00-.46-.64 1.95 1.95 0 00-.66-.4 2.079 2.079 0 00-.76-.14c-.6 0-1.093.18-1.48.54-.373.36-.56.847-.56 1.46 0 .573.18 1.06.54 1.46.373.4.873.6 1.5.6.28 0 .547-.053.8-.16.253-.107.473-.253.66-.44.187-.187.333-.407.44-.66.107-.253.16-.52.16-.8zm.38 6.52c0-.347-.067-.667-.2-.96a2.111 2.111 0 00-.52-.78 2.242 2.242 0 00-.78-.5 2.458 2.458 0 00-.94-.18c-.347 0-.673.06-.98.18a2.52 2.52 0 00-.78.5 2.26 2.26 0 00-.52.76c-.12.293-.18.62-.18.98 0 .747.233 1.327.7 1.74.467.413 1.053.62 1.76.62.693 0 1.273-.207 1.74-.62.467-.413.7-.993.7-1.74z"
      />
    </svg>
  );
});
SvgNumbereight.displayName = "SvgNumbereight";
const MemoForwardRef = memo(SvgNumbereight);
export default MemoForwardRef;
